import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Box, Typography } from '@mui/material';

const MeetingEditor = ({ label, value, onChange, required = false }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
    ],
  };

  return (
    <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: 'text.secondary' }}>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </Typography>

      <Box
        sx={{
          flexGrow: 1,
          minHeight: '220px',
          backgroundColor: '#fff',
          '& .quill': { height: '100%', display: 'flex', flexDirection: 'column' },
          '& .ql-container': {
            flexGrow: 1,
            minHeight: '170px',
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
          },
          '& .ql-toolbar': {
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            bgcolor: '#f5f5f5',
          },
        }}
      >
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
        />
      </Box>
    </Box>
  );
};

export default MeetingEditor;